import React from 'react';
import { handleHeaderInput } from '../edit_quiz_helper/EditQuizHelper';

export function SuggestedTime({time,Contentedit,data,edit_template}){
    let fsize = "sg-time";
    let icon_size = "18";
    if(edit_template === "true")
    {
        fsize="preview_sgtime";
        icon_size = "12";
    }
    return ( 
        <span className={`${fsize} px-1`} > 
        <svg className="me-1" width={`${icon_size}`} height={`${icon_size}`} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7.99935" cy="8.00033" r="6.33333" fill="white" stroke="black" stroke-width="2"/>
            <path d="M11 8.00033H8.25C8.11193 8.00033 8 7.8884 8 7.75033V5.66699" stroke="black" stroke-width="2" stroke-linecap="round"/>
        </svg>
        <span contentEditable={Contentedit} spellcheck="false" data-gramm="false" onInput={handleHeaderInput({
                type: "time_allowed",
                quizdata: data,
              })}>{time}</span> mins</span>
    )
      
      
}